import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

// 1. Main API HTTP link
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_API_URL,
});

// 2. Product API HTTP link
const productHttpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_API_PRODUCT_URL,
});

// Auth middleware – applies to both clients
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "", // Include token only if it exists
    },
  };
});

// Apollo Client for main API
const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

// Apollo Client for product API (with same auth logic)
export const client_product = new ApolloClient({
  link: authLink.concat(productHttpLink),
  cache: new InMemoryCache(),
});

export default client;
